import React, { useState, useEffect, useMemo } from 'react';

import { ZOOM_VALUES } from '@/constants';
import { mapScaleCoefIntoPercentage, getActiveElement } from '@/helpers';

import { PlusIcon, MinusIcon } from '@/components';

import { ButtonWrapperStyled, SliderWrapperStyled, ZoomSliderStyled, ZoomSliderValueStyled } from './styles';

const getSliderArray = () => {
  const result = [];

  for (let i = 0; i < 16; i++) {
    result.push(25 + i * 5);
  }

  for (let i = 1; i < 15; i++) {
    if (100 + i * 25 <= 400) {
      result.push(100 + i * 25);
    } else {
      result.push(400);
    }
  }

  return result;
};

const Slider = props => {
  const { scaleCoef, handleChange } = props;

  const [value, setValue] = useState(ZOOM_VALUES.DEFAULT_VALUE);
  const [sliderValue, setSliderValue] = useState(15);

  const sliderMaxValue = 29;
  const sliderArray = useMemo(() => getSliderArray(), []);

  useEffect(() => {
    const newVal = sliderArray.findIndex(val => val >= value);

    setSliderValue(newVal);
    setValue(mapScaleCoefIntoPercentage(scaleCoef));
  }, [scaleCoef, sliderValue, value]);

  const handleSliderChange = (event, newValue) => {
    handleChange(sliderArray[newValue]);
  };

  const handlePlusClick = () => {
    const newVal = Math.floor(value / 25) * 25;

    handleChange(newVal + 25 <= ZOOM_VALUES.MAX_VALUE ? newVal + 25 : ZOOM_VALUES.MAX_VALUE);
  };

  const handleMinusClick = () => {
    const newVal = Math.ceil(value / 25) * 25;

    handleChange(newVal - 25 >= ZOOM_VALUES.MIN_VALUE ? newVal - 25 : ZOOM_VALUES.MIN_VALUE);
  };

  const handleBlur = () => {
    const activeElement = getActiveElement();

    if (activeElement) {
      activeElement.blur();
    }
  };

  return (
    <SliderWrapperStyled>
      <ButtonWrapperStyled onClick={handleMinusClick}>
        <MinusIcon />
      </ButtonWrapperStyled>

      <ZoomSliderStyled size="small" value={sliderValue} min={0} max={sliderMaxValue} step={1} onChange={handleSliderChange} onChangeCommitted={handleBlur} />

      <ButtonWrapperStyled onClick={handlePlusClick}>
        <PlusIcon />
      </ButtonWrapperStyled>

      <ZoomSliderValueStyled>{`${value} %`} </ZoomSliderValueStyled>
    </SliderWrapperStyled>
  );
};

export default Slider;
